module.exports = __webpack_public_path__ + "img/air-7.c0f3ba0d.jpeg";